import { get } from "lodash";
import { MDBContainer, MDBSideNav } from "mdbreact";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Button from "~/components/common/atoms/Button";
import { partnerInfo } from "~/configs/partnerDetails";
import { VERSION_WEB } from "~/configs/version";
import history from "~/history";
import { redirectToMedproId } from "~/store/login/actions";
import { logOut } from "~/store/user/userAction";
import { urlLogoHeaderWhite } from "~/utils/manageResource";
import styles from "./style.module.scss";

const Drawer = ({
  isDrawer,
  handleToggle,
  IsAuthenticated,
  info,
  logOut,
  redirectToMedproId
}) => {
  const menu = get(partnerInfo, "menu");
  const fullName = get(info, "fullName", "");
  const userName = get(info, "userName", "");
  const displayName = fullName !== "" ? fullName : userName;

  const handleLogout = () => {
    logOut();
    history.push("/");
  };

  menu.map((item, index) => {
    return (
      <li
        className={index === 0 ? styles.first_row : ""}
        key={index}
        onClick={handleToggle}
      >
        <Link to={item.link}>
          <i className={item.icon} />
          {item.name}
        </Link>
      </li>
    );
  });
  return (
    <div className={styles.menu_mobile}>
      <MDBContainer>
        <MDBSideNav
          logo={urlLogoHeaderWhite}
          href="/"
          hidden
          right
          triggerOpening={isDrawer}
          breakWidth={1300}
          showOverlay={false}
          className={styles.bg_menu_mobile}
          onClick={handleToggle}
        >
          <li className={styles.close}>
            <Button color="" key="close-btn" onClick={handleToggle}>
              Đóng
            </Button>
          </li>

          {IsAuthenticated ? (
            <li className={styles.li_sau_dn}>
              <img
                style={{ width: "18px", marginRight: "15px" }}
                src={require("~/assets/img/desktop/logo/medpro_circle.svg")}
                alt="zalo"
              />
              Xin chào&nbsp;<strong>{displayName}</strong>
            </li>
          ) : (
            <li className={styles.li_dangnhap}>
              <Button
                create="create"
                block="block"
                onClick={() => {
                  redirectToMedproId();
                }}
              >
                Đăng nhập tài khoản
              </Button>
            </li>
          )}

          {IsAuthenticated && (
            <>
              <li>
                <Link
                  to={{
                    pathname: "/user",
                    state: { activeItem: 1 }
                  }}
                >
                  <i className="fal fa-user" />
                  Hồ sơ bệnh nhân
                </Link>
              </li>

              <li className={styles.first_row}>
                <Link
                  to={{
                    pathname: "/user",
                    state: { activeItem: 2 }
                  }}
                >
                  <i className="fal fa-file-invoice" />
                  Phiếu khám bệnh
                </Link>
              </li>
            </>
          )}
          <li>
            <Link to="/thac-mac">
              <i className="fal fa-question-circle" />
              Thắc mắc
            </Link>
          </li>
          <li className={styles.first_row}>
            <Link to="/">
              <i className="fal fa-book" />
              Hướng dẫn
            </Link>
          </li>
          <li>
            <a href="/#" title="19002115" className={styles.zalo}>
              <img
                src={require("~/assets/img/desktop/icon/zalo.svg")}
                alt="zalo"
              />
              Hỗ trợ Zalo
            </a>
          </li>
          <li>
            <a href="/#" title="19002115" className={styles.zalo}>
              <img
                src={require("~/assets/img/desktop/icon/facebook.svg")}
                alt="zalo"
              />
              Hỗ trợ Facebook
            </a>
          </li>
          <li>
            <a href="/#" title="19002115">
              <i className="far fa-life-ring" />
              Hỗ trợ kỹ thuật: 1900-2267
            </a>
          </li>
          <li className={styles.first_row}>
            <a href="/#" title="19002115">
              <i className="fal fa-envelope" />
              Email: support@medpro.com.vn
            </a>
          </li>
          {IsAuthenticated && (
            <li
              onClick={() => {
                handleLogout();
              }}
            >
              <a href="/#">
                <i className="fal fa-sign-out-alt" />
                Đăng xuất
              </a>
            </li>
          )}
          <li>
            <i className={styles.version}>Phiên bản: {VERSION_WEB}</i>
          </li>
        </MDBSideNav>
      </MDBContainer>
    </div>
  );
};

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated, info }
  } = state;
  return {
    IsAuthenticated,
    info
  };
};

export default connect(mapStateToProps, {
  logOut,
  redirectToMedproId
})(Drawer);
